/* accessory-upsell.js
   Intercepts product add-to-cart, adds main product via AJAX and shows modal,
   handles accessory AJAX adds and modal controls.
*/
(function(){
  // Helpers
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function showModal() {
    var modal = qs('#accessory-popup');
    if(!modal) return;
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeModal() {
    var modal = qs('#accessory-popup');
    if(!modal) return;
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow = '';
  }
  function renderAddedProduct(item) {
    var container = qs('#accessory-added-product');
    if(!container) return;
    // item returned by /cart/add.js usually has title, quantity, variant_id, product_id and image
    var img = item.image ? '<img src="'+ item.image +'" alt="'+ item.title +'">' : '';
    var html = '<div style="display:flex;align-items:center;gap:12px;">' +
               img +
               '<div class="ap-meta"><div style="font-weight:700;">'+ (item.title || '') +'</div>' +
               '<div style="font-size:13px;color:#666;">Added to cart</div></div></div>';
    container.innerHTML = html;
  }

  // AJAX add to cart: form submit capture
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action^="/cart/add"]');
    if(!form) return;
    // intercept only if the form submit came from product form (handles many themes)
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"], button[name="add"]');
    if(submitBtn) submitBtn.disabled = true;

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(function(resp){
      if(!resp.ok) return resp.json().then(function(err){ throw err; });
      return resp.json();
    })
    .then(function(item){
      // item is the line item added
      renderAddedProduct(item);
      showModal();
      // re-enable submit button
      if(submitBtn) submitBtn.disabled = false;
      // focus first accessory add button for a11y
      var firstBtn = document.querySelector('.acc-add-btn');
      if(firstBtn) firstBtn.focus();
    })
    .catch(function(err){
      if(submitBtn) submitBtn.disabled = false;
      // fallback: proceed with normal submit if AJAX failed
      console.error('Add to cart failed', err);
      form.submit();
    });
  });

  // Close modal events
  document.addEventListener('click', function(e){
    if(e.target.matches('#accessory-close') || e.target.matches('#accessory-continue') || e.target.matches('#accessory-backdrop')) {
      closeModal();
    }
    if(e.target.matches('#accessory-backdrop')) { closeModal(); }
  });

  // Delegate accessory ADD button clicks (AJAX add)
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.acc-add-btn');
    if(!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if(!variantId) {
      // try to find variant id in DOM
      var parent = btn.closest('.acc-item');
      variantId = parent ? parent.querySelector('button.acc-add-btn')?.getAttribute('data-variant-id') : null;
    }
    if(!variantId) {
      alert('Variant not found. Please set first variant ID on the ADD button.');
      return;
    }
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: 'id=' + encodeURIComponent(variantId) + '&quantity=1'
    })
    .then(function(res){ return res.json(); })
    .then(function(item){
      // simple feedback: change button text to "Added"
      btn.textContent = 'Added';
      btn.disabled = true;
      // Optionally update cart count in header if you have function to do so.
    })
    .catch(function(err){
      console.error('Accessory add failed', err);
      btn.disabled = false;
      alert('Could not add accessory.');
    });
  });

  // Trap ESC to close modal
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') {
      var modal = qs('#accessory-popup');
      if(modal && !modal.classList.contains('hidden')) closeModal();
    }
  });

})();
